import { Controller } from "@hotwired/stimulus"

// This controller should be placed on the messages container (e.g., #thread_messages)
// It observes DOM changes and scrolls to the last message after mutations settle
export default class extends Controller {
  connect() {
    this.scrollTimeout = null
    this.scrollToLastMessage({ smooth: true })
    this.observeMutations()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
  }

  observeMutations() {
    this.observer = new MutationObserver(() => {
      this.debouncedScroll()
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  // Debounce scroll to wait for rapid mutations to settle
  // This handles the case where user message and AI placeholder arrive in quick succession
  debouncedScroll() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
    this.scrollTimeout = setTimeout(() => {
      this.scrollToLastMessage({ smooth: true })
    }, 100)
  }

  scrollToLastMessage({ smooth = true } = {}) {
    const lastMessage = this.element.lastElementChild
    if (!lastMessage) return

    const scrollContainer = this.findScrollableParent(this.element)
    if (scrollContainer) {
      const maxScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight
      const top = maxScroll > 0 ? maxScroll : 0
      if (smooth) {
        scrollContainer.scrollTo({ top, behavior: "smooth" })
      } else {
        scrollContainer.scrollTop = top
      }
    }
  }

  findScrollableParent(element) {
    let parent = element.parentElement
    while (parent) {
      const style = getComputedStyle(parent)
      if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
        return parent
      }
      parent = parent.parentElement
    }
    return null
  }
}
